import { Link } from "react-router-dom";

export default function TrustSection() {
  return (
    <section className="py-20 md:py-28 px-4 md:px-6 bg-background-50">
      <div className="max-w-5xl mx-auto relative">
        {/* Black card */}
        <div className="relative bg-primary-500 rounded-[32px] p-8 md:p-12 lg:p-16 overflow-hidden">
          {/* Organic curve decoration */}
          <div className="absolute -top-12 -left-12 w-48 h-48 rounded-full bg-accent-500/20 blur-3xl pointer-events-none"></div>
          <div className="absolute -bottom-16 -right-16 w-56 h-56 rounded-full bg-accent-500/10 blur-3xl pointer-events-none"></div>

          <div className="relative flex flex-col lg:flex-row items-center gap-10 lg:gap-14">
            {/* Left - Photo */}
            <div className="flex-shrink-0">
              <div className="w-40 h-48 md:w-48 md:h-56 rounded-2xl overflow-hidden -mt-24 lg:-mt-20 lg:-ml-8 border-4 border-background-50 shadow-lg">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20confident%20young%20woman%20with%20curly%20dark%20hair%20wearing%20a%20soft%20oatmeal%20colored%20knit%20sweater%20against%20a%20warm%20cream%20studio%20backdrop%20with%20gentle%20rim%20lighting%20creating%20a%20subtle%20glow%20around%20her%20silhouette%20editorial%20portrait%20photography%20with%20natural%20relaxed%20expression%20and%20clean%20minimal%20composition&width=600&height=750&seq=trust-editor-v2-02&orientation=portrait"
                  alt="AllChinaBuy Spreadsheet editor"
                  title="AllChinaBuy Spreadsheet Shopping Research Team"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
            </div>

            {/* Right - Text */}
            <div className="flex-1 text-center lg:text-left">
              <span className="font-heading text-6xl md:text-7xl text-accent-300/40 leading-none block mb-4">
                &ldquo;
              </span>
              <blockquote className="text-base md:text-lg lg:text-xl text-background-50 leading-relaxed mb-6">
                The AllChinaBuy Spreadsheet completely changed how I discover products online. Instead of spending hours searching across different sites, I have everything organized in one place with trusted links and real community feedback. It is honestly the most useful shopping resource I have found.
              </blockquote>

              <div className="mb-6">
                <p className="text-sm font-semibold text-background-50">Sarah Mitchell</p>
                <p className="text-xs text-background-50/60">Senior Shopping Editor &mdash; 4+ Years Experience</p>
              </div>

              <Link
                to="/guide/allchinabuy-sheet-complete-guide"
                className="inline-flex items-center gap-2 px-6 py-2.5 bg-accent-200 text-accent-900 rounded-full text-sm font-semibold hover:bg-accent-300 transition-all whitespace-nowrap cursor-pointer"
              >
                Read Buying Guide
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}